export const EmbroideryThreadColumns = [
    "product_code",
    "color",
    "shade_number",
    "tex",
    "consumption",
    "mtrs_per_cone"
]


export class ExternalReq {
    externalRef?: string;

    constructor(externalRef: string) {
        this.externalRef = externalRef
    }
}

export const Threadscolumns = [
    "style_id",
    "tex",
    "part",
    "quality",
    "colour_combo",
    "colour_code",
    "shade_number",
    "supplier"
]
